import React, { useEffect, useRef } from 'react'
import { Link } from 'gatsby'
import slideAcross from '../utils/slide'

import benefitsList from '../data/benefitsList'

function Benefits() {
	const slide = useRef()

	useEffect(() => {
		slideAcross([slide.current])
	}, [])

	return (
		<section className='benefits' id='beneficios'>
			<div className='benefits__content'>
				<h2 className='benefits__title' ref={slide} data-slide='right'>
					Beneficios
				</h2>
				<div className='container' data-aos='fade-left' data-aos-delay='600'>
					<p>
						En constante búsqueda para que todas las inversiones se mantengan activas y productivas,
						dándole continuidad al ciclo de ocupación.
					</p>
					<p>
						<span className='upper'>
							El cuidado de los clientes facilitará el cumplimiento del contrato,
						</span>{' '}
						teniendo como eje central la comunicación y organización; que serán la clave de una
						buena administración.
					</p>

					<div className='benefits-list'>
						{benefitsList().map(link => (
							<Link className='benefits-list__link' to={`/beneficios/${link.url}`} key={link.url}>
								<i className='icon icon-arrow-right' />
								<span>{link.text}</span>
							</Link>
						))}
					</div>
				</div>
			</div>
		</section>
	)
}

export default Benefits
